// eslint-disable-next-line require-jsdoc
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// IDS Components
import { useSelector } from 'react-redux';

// assests
import { Card, CardContent } from '@ids-beta/cards';
import { Link } from 'react-router-dom';
import Button from '@ids/button';
import { addItemToCart } from '../../services/commonDataService';
import Loader from '../Common/Loader';
import { getImageSrc } from '../Util/CommonUtils';

// eslint-disable-next-line require-jsdoc
export const Recommended = (props) => {
  const { pageData, history, outOfStockList } = props;

  const alsoRecommended = pageData.AlsoRecommended;
  const [loading, setLoading] = useState(false);
  const mainReducer = useSelector((state) => state.mainReducer);

  const ProductOutOfStockisOutOfStockPhase4 =
    mainReducer.clientConfigs &&
    mainReducer.clientConfigs.ProductOutOfStockisOutOfStockPhase4 &&
    mainReducer.clientConfigs.ProductOutOfStockisOutOfStockPhase4.toLowerCase() === 'true';

  const handleAddToCart = (pfId, sku) => {
    setLoading(true);
    addItemToCart(sku, pfId)
      .then(() => {
        props.logToIMWebLogger('info', `Recommended.jsx: handleAddToCart success for sku: ${sku}.`);
        window.open('/cart', '_self');
        setLoading(false);
      })
      .then((err) => {
        props.logToIMWebLogger(
          'error',
          `Recommended.jsx: handleAddToCart failed for sku: ${sku}. Error: ${err}`,
        );
        setLoading(false);
      });
  };

  const checkOFS = (pfid) => {
    if (
      ProductOutOfStockisOutOfStockPhase4 &&
      outOfStockList !== null &&
      outOfStockList.length > 0
    ) {
      const ofsPfid = outOfStockList[0].pfidList.find((element) => element.pfid === pfid);

      if (ofsPfid) {
        return ofsPfid.outOfStockMessage;
      }
      return false;
    }
    return false;
  };

  return (
    <div className="footer-main-section">
      <div className="container-center-lg">
        <div className="footer-section">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h2>{alsoRecommended.Header}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {alsoRecommended.Items &&
            alsoRecommended.Items.map((ele, key) => {
              return (
                <div key={key} className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                  <Card style={{ margin: '40px', height: '82%' }} styleOverrideReason="none">
                    <img src={getImageSrc(ele.Image)} alt="..." />
                    <CardContent>
                      <p className="font-wgt-500 margin-bottom-20">{ele.Title}</p>
                      {ele.Desc.map((d, k) => {
                        return (
                          <p key={k} className="margin-bottom-20 prod-sub-header">
                            {d}
                          </p>
                        );
                      })}

                      {ele.LearnMoreLinkEnabled ? (
                        <Link to={ele.LearnMoreLink} className="learn-more">
                          <p
                            className="margin-bottom-20"
                            style={{ fontSize: '15px' }}
                          >{`Learn more about ${ele.Title}`}</p>
                        </Link>
                      ) : (
                        <a href={ele.LearnMoreLink} className="learn-more">
                          <p
                            className="margin-bottom-20"
                            style={{ fontSize: '15px' }}
                          >{`Learn more about ${ele.Title}`}</p>
                        </a>
                      )}
                      {checkOFS(ele.PFID) ? (
                        <p className="ofs-message-secure-products margin-12x">
                          {checkOFS(ele.PFID)}
                        </p>
                      ) : ele.ButtonText === 'Add to cart' ? (
                        <Button
                          className="action-button"
                          onClick={() => handleAddToCart(ele.PFID, ele.Sku)}
                          theme="intuit"
                          styleOverrideReason="none"
                          data-ui-object="button"
                          data-refer-ui-access-point={`add_to_cart| ${ele.Title}`}
                        >
                          {ele.ButtonText}
                        </Button>
                      ) : (
                        <Button
                          className="action-button"
                          onClick={() =>
                            ele.ButtonLinkEnabled
                              ? history.push(ele.ButtonLink)
                              : window.open(ele.ButtonLink, '_self')
                          }
                          theme="intuit"
                          styleOverrideReason="none"
                          data-ui-object="button"
                          data-refer-ui-access-point={`get_started| ${ele.Title}`}
                        >
                          {ele.ButtonText}
                        </Button>
                      )}
                    </CardContent>
                  </Card>
                </div>
              );
            })}
        </div>
      </div>
      <Loader show={loading} loadingText="Loading..." />
    </div>
  );
};

Recommended.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pageData: PropTypes.object.isRequired,
};
